export default function Logo({ className = "w-9 h-9", withText = true, subtitle = "South Yorkshire, UK" }) {
  return (
    <span className="flex items-center gap-3">
      <svg className={`${className} text-[#1e9bff] shrink-0`} viewBox="0 0 40 40" fill="none" aria-hidden="true">
        <path d="M4 22L20 8L36 22" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 26C14 23 20 18 20 18C20 18 26 23 26 26C26 29.3 23.3 32 20 32C16.7 32 14 29.3 14 26Z" fill="#1e9bff" fillOpacity="0.3" stroke="currentColor" strokeWidth="2" />
        <path d="M29 11L30 14L33 15L30 16L29 19L28 16L25 15L28 14L29 11Z" fill="#1e9bff" />
      </svg>
      {withText && (
        <span className="leading-none">
          <span className="font-display text-xl tracking-tight text-white block uppercase" data-testid="brand-name">SY Exterior Cleaning</span>
          <span className="text-[10px] tracking-[0.18em] uppercase text-[#1e9bff] font-mono-lbl">{subtitle}</span>
        </span>
      )}
    </span>
  );
}
